import React from 'react';
import AuthService from '../util/Authenticate';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        AuthService.isAuthenticated() ? (
            <Component {...props}/>
        ) : (
            <Redirect to={{
                pathname: '/',
                state: { from: props.location }
            }}/>
        )
    )}/>
)

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js